import { ComponentUtils } from '@/mixins';
import ShCard from '@/components/Helpers/ShCard';

// @vue/component
export default {
  name: 'WidgetFooterPreview',

  components: {
    ShCard,
  },

  mixins: [ComponentUtils],

  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedScreen: 'welcome',
      focusedElement: null,
    };
  },

  created() {
    this.mMakeCopyFromProps('widget');
  },

  beforeDestroy() {
    this.$EventBus.$off('WidgetScreensConfiguration/SET_FOCUS_TO_EDITED_ELEMENT');
  },
};
